import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { checkUrlIsExternal } from '../Shared/CheckUrl';
import { SplideTrack, SplideSlide, Splide } from '@splidejs/react-splide';
export default function Navbar(props) {
    var closeMobileNav = props.closeMobileNav, menuData = props.menuData, rootUrl = props.rootUrl, generalSettings = props.generalSettings, reverseMenuBar = props.reverseMenuBar, overlapMenu = props.overlapMenu;
    var prevScrollY = useRef(0);
    var defaultNavHeight = useRef(0);
    var wasScrolledUp = useRef(false);
    var isNavHovered = useRef(false);
    var hideNavTimeout = useRef(null);
    var navElement = useRef(null);
    var menuNavigationList = useRef(null);
    var navPlaceholderElement = useRef(null);
    var _a = useState(null), hoverNavIndex = _a[0], setHoverNavIndex = _a[1];
    var _b = useState(null), clickNavIndex = _b[0], setClickNavIndex = _b[1];
    var _c = useState(false), menuOpened = _c[0], setMenuOpened = _c[1];
    var _d = useState(false), isOnMobile = _d[0], setIsOnMobile = _d[1];
    var handleItemClick = function (e) {
        //e.target.closest("ul").classList.remove("active")
        e.target.nextSibling.classList.add("active");
    };
    var handleBack = function (e) {
        e.target.closest("ul").classList.remove("active");
        //e.target.closest("ul").closest("li").closest("ul").classList.add("active")
    };
    useEffect(function () {
        setIsOnMobile(window.innerWidth <= 991);
    }, []);
    useEffect(function () {
        if (navElement.current && reverseMenuBar) {
            navElement.current.classList.add('reverse-menu-bar');
        }
        else if (navElement.current) {
            navElement.current.classList.remove('reverse-menu-bar');
        }
        if (navElement.current && overlapMenu) {
            navElement.current.classList.add('overlap-menu');
        }
        else if (navElement.current) {
            navElement.current.classList.remove('overlap-menu');
        }
    }, [reverseMenuBar, overlapMenu]);
    useEffect(function () {
        setIsOnMobile(window.innerWidth <= 991);
    }, []);
    useEffect(function () {
        var _a, _b;
        var handleKeyDown = function (event) {
            if (event.key === 'Escape') {
                setMenuOpened(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        var splideElement = document.querySelector('.menu-drawer .splide');
        if (splideElement) {
            if (menuOpened) {
                splideElement.classList.add('is-initialized');
            }
            else {
                splideElement.classList.remove('is-initialized');
            }
        }
        if (menuOpened) {
            document.body.classList.add('has-overlay');
            (_a = navElement.current) === null || _a === void 0 ? void 0 : _a.classList.add('opened');
        }
        else {
            document.body.classList.remove('has-overlay');
            (_b = navElement.current) === null || _b === void 0 ? void 0 : _b.classList.remove('opened');
        }
        return function () {
            document.body.classList.remove('has-overlay');
        };
    }, [menuOpened]);
    useEffect(function () {
        window.addEventListener('click', handleClickOutside);
        return function () {
            window.removeEventListener('click', handleClickOutside);
        };
    }, []);
    var handleClickOutside = function (event) {
        if (navElement.current && !event.composedPath().includes(navElement.current) && !isOnMobile) {
            setMenuOpened(false);
        }
    };
    function areNumbersEqualWithMargin(number1, number2, margin) {
        return Math.abs(number1 - number2) <= margin;
    }
    useEffect(function () {
        var handleResize = function () {
            if (navElement.current && navElement.current.classList.contains('nav-fixed')) {
                defaultNavHeight.current = navElement.current.getBoundingClientRect().height || 0;
            }
            if (navPlaceholderElement.current && navElement.current) {
                navPlaceholderElement.current.style.height = defaultNavHeight.current + 'px';
            }
            setIsOnMobile(window.innerWidth <= 991);
        };
        handleResize();
        var handleNavVisibility = function (forceHide) {
            var _a, _b;
            if (forceHide === void 0) { forceHide = false; }
            var navHeight = defaultNavHeight.current || (((_a = navElement.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0);
            var initialNav = true;
            var goingUp = false;
            var navTop = true;
            var scrollUpVisible = false;
            var currentScrollY = window.scrollY;
            if (currentScrollY > navHeight) {
                initialNav = true;
                wasScrolledUp.current = wasScrolledUp.current || prevScrollY.current > currentScrollY;
            }
            else {
                wasScrolledUp.current = false;
                if (currentScrollY === 0) {
                    initialNav = false;
                }
            }
            if (prevScrollY.current < currentScrollY && goingUp) {
                goingUp = false;
            }
            if (prevScrollY.current > currentScrollY && !goingUp) {
                goingUp = true;
            }
            navTop = window.pageYOffset === 0;
            scrollUpVisible = window.pageYOffset > navHeight;
            prevScrollY.current = currentScrollY;
            var scrollUpDownClass = initialNav
                ? goingUp
                    ? scrollUpVisible
                        ? 'scroll-up'
                        : ''
                    : wasScrolledUp.current
                        ? 'scroll-down'
                        : ''
                : '';
            var navFixedClass = navTop ? 'nav-fixed' : '';
            clearTimeout(hideNavTimeout.current);
            if (navElement.current) {
                navElement.current.classList.remove('scroll-up');
                navElement.current.classList.remove('scroll-down');
                navElement.current.classList.remove('nav-fixed');
                if (scrollUpDownClass) {
                    navElement.current.classList.add(scrollUpDownClass);
                }
                if (navFixedClass) {
                    navElement.current.classList.add(navFixedClass);
                }
            }
            if (navPlaceholderElement.current) {
                navPlaceholderElement.current.style.display = scrollUpDownClass ? 'block' : 'none';
            }
            var currentNavHeight = ((_b = navElement.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
            if ((navFixedClass || !scrollUpDownClass) && !areNumbersEqualWithMargin(currentNavHeight, navHeight, 10)) {
                handleResize();
            }
        };
        var handleScroll = function () {
            handleNavVisibility();
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(function () {
        if (closeMobileNav) {
            document.body.classList.add('overflow-hidden');
        }
        else {
            document.body.classList.remove('overflow-hidden');
        }
    }, [closeMobileNav]);
    var mouseEnterNav = function (i) {
        setHoverNavIndex(i);
    };
    var mouseLeaveNav = function () {
        setHoverNavIndex(null);
    };
    var clickNav = function (e, i) {
        if (e.key === 'Enter' || e.charCode === 13) {
            if (clickNavIndex === i) {
                setClickNavIndex(null);
            }
            else {
                setClickNavIndex(i);
            }
        }
    };
    var handleDivBlur = function (i) {
        if (clickNavIndex !== i) {
            setClickNavIndex(null);
        }
    };
    var handleNavMouseOver = function () {
        isNavHovered.current = true;
    };
    var handleNavMouseOut = function () {
        isNavHovered.current = false;
    };
    var TitleComponent = function (_a) {
        var tag = _a.tag, classes = _a.classes, children = _a.children;
        var Tag = tag;
        return React.createElement(Tag, { className: classes }, children);
    };
    var navBarItems = function (item, i) {
        return (React.createElement(React.Fragment, { key: i },
            React.createElement("li", { className: 'nav-item' +
                    (item.children ? ' has-children' + (hoverNavIndex === i ? ' minus' : ' plus') : ''), onMouseEnter: function () { return mouseEnterNav(i); }, onMouseLeave: mouseLeaveNav, onBlur: function () { return handleDivBlur(i); } },
                item.fields.title && (item.fields.link || item.fields.link.length === 0) && (React.createElement(React.Fragment, null,
                    checkUrlIsExternal(item.fields.link) && item.fields.link.length > 0 && (React.createElement("a", { href: item.fields.link && item.fields.link.length > 0 ? item.fields.link : '#', onClick: function (e) {
                            if (!(item.fields.link || '').length) {
                                e.preventDefault();
                            }
                        }, target: item.fields.openinNewWindow ? '_blank' : '_self', rel: item.fields.openinNewWindow ? 'noopener noreferrer' : '', title: item.fields.title, tabIndex: 0 }, item.fields.title)),
                    !checkUrlIsExternal(item.fields.link) &&
                        item.fields.link.length === 0 &&
                        item.children && React.createElement("span", null, item.fields.title),
                    !checkUrlIsExternal(item.fields.link) && item.fields.link.length > 0 && (React.createElement(Link, { to: item.fields.link, target: item.fields.openinNewWindow ? '_blank' : '_self', rel: item.fields.openinNewWindow ? 'noopener noreferrer' : '', title: item.fields.title, tabIndex: 0 }, item.fields.title)),
                    item.children && (React.createElement("button", { type: "submit", value: "Submit", "aria-label": "Close", className: 'btn btn-more-icon border-0 bg-transparent ' + (clickNavIndex === i ? 'minus' : ''), onKeyDown: function (e) { return clickNav(e, i); } })))),
                item.children && (React.createElement("ul", { className: 'children-items ' + ((hoverNavIndex === i || clickNavIndex === i) ? 'active' : '') }, item.children.map(function (child, j) {
                    return (React.createElement("li", { className: "child", key: j },
                        React.createElement("i", { className: "fa-solid fa-arrow-right" }),
                        React.createElement(Link, { to: child.fields.link, target: child.fields.openinNewWindow ? '_blank' : '_self', rel: child.fields.openinNewWindow ? 'noopener noreferrer' : '', title: child.fields.title, onClick: function () {
                                setClickNavIndex(null);
                                setMenuOpened(false);
                            } }, child.fields.title)));
                }))))));
    };
    var drawMenu = function (menu) {
        return (React.createElement(React.Fragment, { key: menu.fields.mainmenufolderID },
            React.createElement("div", { className: "menu-drawer w-100 ".concat(menuOpened ? 'opened' : '') },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-3" },
                            React.createElement("div", { className: "d-flex flex-column justify-content-center h-100 lef-side-col" },
                                React.createElement("div", { className: "title mt-4" },
                                    React.createElement(TitleComponent, { tag: menu.fields.titleTag, classes: menu.fields.titleStyle }, menu.fields.navbarAnnoucementTitle)),
                                React.createElement("div", { className: "sub-title" },
                                    React.createElement(TitleComponent, { tag: menu.fields.subtitleTag, classes: menu.fields.subtitleStyle }, menu.fields.navbarAnnoucementSubtitle)))),
                        React.createElement("div", { className: "col-9 right-side-col" },
                            React.createElement("div", { className: "featured-carousel-items-col text-stone", itemScope: true, itemType: "https://schema.org/ItemList" },
                                React.createElement(Splide, { options: {
                                        type: 'slide',
                                        drag: true,
                                        perPage: 3,
                                        pagination: false,
                                        arrows: false,
                                        gap: '10px',
                                    }, hasTrack: false },
                                    React.createElement(SplideTrack, null, menu.children &&
                                        menu.children.length > 0 &&
                                        menu.children.map(function (item, j) {
                                            var _a, _b, _c, _d, _e, _f, _g, _h;
                                            return (React.createElement(SplideSlide, { key: j, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/Place" },
                                                item.fields.link && (React.createElement("a", { href: item.fields.link, title: item.fields.title },
                                                    React.createElement("div", { className: "splide-card justify-content-between d-flex flex-column" },
                                                        item.fields.image && (React.createElement("div", { className: "img-container" },
                                                            React.createElement("img", { src: item.fields.image, className: "rounded rounded-5 w-100 h-auto", alt: (_b = (_a = item.fields.image_description) !== null && _a !== void 0 ? _a : item.fields.title) !== null && _b !== void 0 ? _b : '', title: (_d = (_c = item.fields.image_title) !== null && _c !== void 0 ? _c : item.fields.title) !== null && _d !== void 0 ? _d : '', itemProp: "image" }))),
                                                        item.fields.title && (React.createElement("span", { className: "title-image", itemProp: "title" }, item.fields.title))))),
                                                !item.fields.link && (React.createElement("div", { className: "splide-card justify-content-between border-radius d-flex flex-column" },
                                                    item.fields.image && (React.createElement("div", { className: "img-container" },
                                                        React.createElement("img", { src: item.fields.image, className: "rounded rounded-5 w-100 h-auto", alt: (_f = (_e = item.fields.image_description) !== null && _e !== void 0 ? _e : item.fields.title) !== null && _f !== void 0 ? _f : '', title: (_h = (_g = item.fields.image_title) !== null && _g !== void 0 ? _g : item.fields.title) !== null && _h !== void 0 ? _h : '', itemProp: "image" }))),
                                                    item.fields.title && (React.createElement("span", { className: "title-image", itemProp: "title" }, item.fields.title))))));
                                        }))))))))));
    };
    var drawMobileMenu = function (menu) {
        var _a;
        return (React.createElement(React.Fragment, { key: menu.fields.mainmenufolderID },
            React.createElement("div", { className: "menu-drawer mobile-drawer w-100 ".concat(menuOpened ? 'opened' : '') },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement("div", { className: "d-flex flex-column justify-content-center h-100" },
                                React.createElement("div", { className: "sub-title" },
                                    React.createElement("span", { className: "collection-title" }, menu.name))))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement("div", { className: "list-cards" }, (_a = menu === null || menu === void 0 ? void 0 : menu.children) === null || _a === void 0 ? void 0 : _a.map(function (item, j) {
                                var _a = item.fields, link = _a.link, title = _a.title, image = _a.image, image_description = _a.image_description;
                                var cardContent = (React.createElement("div", { className: "justify-content-between d-flex flex-column card-details" },
                                    image && (React.createElement("div", { className: "img-container" },
                                        React.createElement("img", { src: image, className: "rounded rounded-5 w-100 h-auto", alt: image_description || title || '', title: title || '', itemProp: "image" }))),
                                    title && (React.createElement("span", { className: "title-image", itemProp: "title" }, title))));
                                return link ? (React.createElement("a", { className: "collection-card", href: link, title: title, key: j, onClick: function () { return setMenuOpened(!menuOpened); } }, cardContent)) : (React.createElement("div", { className: "collection-card", key: j }, cardContent));
                            }))))))));
    };
    var renderMenuLink = function (item, iteration) {
        var _a, _b;
        return (React.createElement("li", { key: item.id, className: "nav-item".concat(item.children ? ' has-children' : '') },
            item.children && (React.createElement(React.Fragment, null,
                React.createElement("span", { onClick: handleItemClick }, item.fields.title),
                mobileNavBarItems(item.children, item.fields.title, iteration + 1, item.fields))),
            !item.children ? (React.createElement(React.Fragment, null,
                !checkUrlIsExternal(item.fields.link) && ((_a = item.fields.link) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(Link, { to: item.fields.link, target: item.fields.openinNewWindow ? '_blank' : '_self', rel: item.fields.openinNewWindow ? 'noopener noreferrer' : '', title: item.fields.title, onClick: function () { return setMenuOpened(false); }, tabIndex: 0 }, item.fields.title)),
                checkUrlIsExternal(item.fields.link) && ((_b = item.fields.link) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("a", { href: item.fields.link, onClick: function (e) {
                        if (!item.fields.link)
                            e.preventDefault();
                    }, target: item.fields.openinNewWindow ? '_blank' : '_self', rel: item.fields.openinNewWindow ? 'noopener noreferrer' : '', title: item.fields.title, tabIndex: 0 }, item.fields.title)))) : null));
    };
    var mobileNavBarItems = function (items, parrentName, iteration, parrentData) {
        return (React.createElement("ul", { className: "primary-nav mobile-menu list-unstyled d-flex flex-column d-lg-none level-".concat(iteration, " ").concat(iteration === 1 ? "active" : "") },
            iteration > 1 && (React.createElement("li", { className: "back-navigation-item", onClick: function (e) { return handleBack(e); } }, "".concat(parrentName))),
            iteration > 1 && parrentData.exploreAll && (React.createElement("li", { className: "nav-item" },
                React.createElement(Link, { to: parrentData.link, target: parrentData.openinNewWindow ? '_blank' : '_self', rel: parrentData.openinNewWindow ? 'noopener noreferrer' : '', title: parrentData.exploreAll, onClick: function () { return setMenuOpened(false); }, tabIndex: 0 }, parrentData.exploreAll))),
            items.filter(function (e) { return e.stripClassName === "sky23.mainmenuitem"; }).map(function (item) { return (renderMenuLink(item, iteration)); })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { ref: navElement, id: "navbar", onMouseOver: handleNavMouseOver, onMouseOut: handleNavMouseOut, className: "navbar p-0 nav-fixed" },
            React.createElement("div", { className: "container d-block position-relative", itemScope: true, itemType: "https://schema.org/Organization" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center navbar-top" },
                            React.createElement(Link, { to: rootUrl || '/', className: "navbar-brand", id: "homePageLink", title: "Pursuit Logo", "aria-label": "Pursuit Logo", onClick: function () { return setMenuOpened(false); } }, generalSettings.fields.logo && (React.createElement("img", { src: generalSettings.fields.logo, alt: generalSettings.fields.logo_description ? generalSettings.fields.logo_description : 'Pursuit Logo', title: generalSettings.fields.logo_title ? generalSettings.fields.logo_title : 'Pursuit Logo', height: "42", className: "header-logo img-fluid", itemProp: "logo" }))),
                            React.createElement("div", { className: "menu-toggler" },
                                React.createElement("button", { className: "bg-transparent border-0 d-inline-flex align-items-center d-block d-lg-none", title: menuOpened ? "Close Menu" : "Open Menu", onClick: function () { return setMenuOpened(!menuOpened); } }, " ")))))),
            React.createElement("div", { className: "divider d-none d-lg-block" }, " "),
            React.createElement("div", { className: "main-menu w-100" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row flex-wrap w-100" },
                        React.createElement("div", { className: "col d-flex justify-content-between nav-menu w-100", id: "menu-navigation" },
                            React.createElement("div", { className: "menu-container" },
                                React.createElement("div", { className: "menu-toggler" },
                                    React.createElement("button", { className: "bg-transparent border-0 d-inline-flex align-items-center d-none d-lg-block", onClick: function () { return setMenuOpened(!menuOpened); } }, menuData &&
                                        (function () {
                                            var menuFolder = menuData.children.find(function (e) { return e.stripClassName === 'sky23.mainmenufolder'; });
                                            return menuFolder ? React.createElement("span", { className: "ms-2" }, menuFolder.name) : null;
                                        })())),
                                menuOpened && (React.createElement("div", { className: "links position-relative h-100 d-lg-none d-block", style: { height: "240px" } }, mobileNavBarItems(menuData.children, 'menu', 1, menuData.fields)))),
                            React.createElement("div", { className: "links d-none d-lg-flex justify-content-end p-0 w-100" },
                                React.createElement("ul", { className: "primary-nav list-unstyled d-flex align-items-center m-0" }, menuData &&
                                    menuData.children
                                        .filter(function (e) { return e.stripClassName === 'sky23.mainmenuitem'; })
                                        .map(function (item, i) {
                                        return navBarItems(item, i);
                                    })))),
                        menuData &&
                            isOnMobile &&
                            (function () {
                                var menuFolder = menuData.children.find(function (e) { return e.stripClassName === 'sky23.mainmenufolder'; });
                                return menuFolder.children ? drawMobileMenu(menuFolder) : null;
                            })()))),
            menuData &&
                !isOnMobile &&
                (function () {
                    var menuFolder = menuData.children.find(function (e) { return e.stripClassName === 'sky23.mainmenufolder'; });
                    return menuFolder.children ? drawMenu(menuFolder) : null;
                })())));
}
